import { IAtomSelectItem } from '@/components/atoms/AtomSelect/AtomSelect.type'

export interface BatchStatisticsGetSelectItemResult {
  items: IAtomSelectItem[]
}

export function BatchStatisticsGetSelectItemResultFromJSON(
  json: any
): BatchStatisticsGetSelectItemResult {
  const resp = JSON.parse(json)
  return {
    items: resp
  }
}
